import './MixFocus.css';

import { cn } from '../../utils/bem';

export const cnMixFocus = cn('MixFocus');
